import Vue from 'vue'
import Axios from 'axios'
import qs from 'qs'
import {encode as base64Encode} from 'base-64'
import {encode as utf8Encode} from 'utf8'

Vue.prototype.$hidePageLoading = function () {
  // alert(3)
  setTimeout(function () {
    $('.loading').hide('slow')
    $('.loading-img').hide('slow')
    $('body').css({
      'overflow': 'visible'
    })
  }, 300)
}

Vue.prototype.$showPageLoading = function () {
  // alert(3)
  setTimeout(function () {
    $('.loading').show('slow')
    $('.loading-img').show('slow')
    $('body').css({
      'overflow': 'visible'
    })
  }, 300)
}

Vue.prototype.$clearLocalStorage = function () {
  try {
    // this.$localStorage.remove('sl')
    // this.$localStorage.set('st', this.selectedProfileAndTest)
    // this.$localStorage.get('get')
    // this.$localStorage.set('sl', lab, 30 * 60 * 1000)

    this.$localStorage.remove('access_token')
    // this.$localStorage.remove('refresh_token')
    this.$localStorage.remove('token_type')
    this.$localStorage.remove('expires_in')
    this.$localStorage.remove('scope')
    this.$localStorage.remove('loggedIn')
    this.$localStorage.remove('userid')
    this.$localStorage.remove('email')
    this.$localStorage.remove('profile')
  } catch (e) {
    console.error(e)
  }
}

Vue.prototype.$clearLocalStorageForLogout = function () {
  try {
    this.$localStorage.remove('access_token')
    this.$localStorage.remove('refresh_token')
    this.$localStorage.remove('token_type')
    this.$localStorage.remove('expires_in')
    this.$localStorage.remove('scope')
    this.$localStorage.remove('loggedIn')
    this.$localStorage.remove('userid')
    this.$localStorage.remove('email')
    this.$localStorage.remove('profile')
    this.$localStorage.remove('st')
    this.$localStorage.remove('sl')
    this.$localStorage.remove('ct')
    this.$localStorage.remove('sa')
    this.$localStorage.remove('sm')
    this.$localStorage.remove('cou')
    this.$clientTokenForLogout()
  } catch (e) {
    console.error(e)
  }
}

global.ClearTimeout = undefined;
Vue.prototype.$clientToken = async function () {
  try {
    if(this.$localStorage.get('refresh_token')) {
       return this.$refreshToken()
    }else {
      return this.$clientCredentialToken()
    }
  } catch (e) {
    console.error(e)
  }
}

Vue.prototype.$clientCredentialToken = async function () {
  try {
      let params = {
        'grant_type': 'client_credentials'
      }
      let text = 'user:user'
      let bytes = utf8Encode(text)
      let encoded = base64Encode(bytes)
      let headers = {
        headers: {
          'Authorization': 'Basic ' + encoded,
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }
      return await Axios.post(this.$apiUrl + 'oauth/token', qs.stringify(params), headers).then(resp => {
        if (!resp.data.error) {
          // this.$clearLocalStorage()
          this.$localStorage.set('access_token', resp.data.access_token, (resp.data.expires_in * 1000))
          this.$localStorage.set('token_type', resp.data.token_type, (resp.data.expires_in * 1000))
          this.$localStorage.set('expires_in', resp.data.expires_in, (resp.data.expires_in * 1000))
          this.$localStorage.set('loggedIn', false, (resp.data.expires_in * 1000))
          this.$localStorage.remove('userid')
          this.$localStorage.remove('email')
          this.$localStorage.remove('refresh_token')
          this.$localStorage.remove('scope')
          this.$localStorage.remove('profile')

          console.log('ct')
          if(global.ClearTimeout){
            clearTimeout(global.ClearTimeout)
          }
          global.ClearTimeout = setTimeout(function() {
            this.$clientCredentialToken()
          }.bind(this), (resp.data.expires_in - (60 * 60)) * 1000)
          return false
        }else{
          this.$clientCredentialToken()
        }
      }).catch(e => {
        console.log(e)
        return {
          error: e
        }
      })
  } catch (e) {
    console.error(e)
  }
}

Vue.prototype.$clientTokenForLogout = async function () {
  try {
    if (this.$localStorage.get('access_token') === null) {
      let params = {
        'grant_type': 'client_credentials'
      }
      let text = 'user:user'
      let bytes = utf8Encode(text)
      let encoded = base64Encode(bytes)
      let headers = {
        headers: {
          'Authorization': 'Basic ' + encoded,
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }
      return await Axios.post(this.$apiUrl + 'oauth/token', qs.stringify(params), headers).then(response => {
        if (!response.data.error) {
          this.$localStorage.set('access_token', response.data.access_token, (response.data.expires_in * 1000))
          this.$router.push('/')
        }
      }).catch(e => {
        console.log(e)
        return {
          error: e
        }
      })
    }
  } catch (e) {
    console.error(e)
  }
}

Vue.prototype.$logon = async function (username, password) {
  try {
    let params = {
      'grant_type': 'password',
      'username': username,
      'password': password
    }
    let text = 'patient:patient'
    let bytes = utf8Encode(text)
    let encoded = base64Encode(bytes)
    let headers = {
      headers: {
        'Authorization': 'Basic ' + encoded,
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }
    return await Axios.post(this.$apiUrl + 'oauth/token', qs.stringify(params), headers).then(resp => {
      if (!resp.data.error) {
        // this.$clearLocalStorage()
        this.$localStorage.set('access_token', resp.data.access_token, (resp.data.expires_in * 1000))
        this.$localStorage.set('refresh_token', resp.data.refresh_token)
        this.$localStorage.set('token_type', resp.data.token_type, (resp.data.expires_in * 1000))
        this.$localStorage.set('expires_in', resp.data.expires_in, (resp.data.expires_in * 1000))
        this.$localStorage.set('scope', resp.data.scope, (resp.data.expires_in * 1000))
        this.$localStorage.set('loggedIn', true, (resp.data.expires_in * 1000))
        this.$localStorage.set('userid', resp.data.user.userId, (resp.data.expires_in * 1000))
        this.$localStorage.set('email', resp.data.user.email, (resp.data.expires_in * 1000))
        
        console.log('at')
        if(global.ClearTimeout){
          clearTimeout(global.ClearTimeout)
        }
        global.ClearTimeout = setTimeout(function() {
          this.$refreshToken()
        }.bind(this), (resp.data.expires_in - (60 * 60)) * 1000)
        return Axios.get(this.$apiUrl + 'patient/getProfile', {
          headers: {
            'Authorization': 'Bearer ' + resp.data.access_token,
            'Content-type': 'application/json'
          }
        }).then(response => {
          if (response.data.response_code === 0) {
            let result = response.data.response
            let userDetails = {
              'username': result.Patient.firstName + ' ' + result.Patient.lastName,
              'firstName': result.Patient.firstName,
              'lastName': result.Patient.lastName,
              'photo': result.Patient.photo,
              'dob': result.Patient.dob,
              'phone1': result.Patient.phone1,
              'phone2': result.Patient.phone2,
              'sex': result.Patient.sex,
              'email': result.email,
              'credits': result.Patient.creditPoint
            }
            this.$localStorage.set('profile', userDetails, 0)
            return {
              msg: 'success',
              data: resp.data.user
            }
          } else {
            console.log(response.data.response_message)
            return {
              error: response.data.response_message
            }
          }
        }).catch(e => {
          console.log(e)
          return {
            error: e
          }
        })
      } else {
        return {
          error: 'Wrong Username/Password combination'
        }
      }
    }).catch(e => {
      console.log(e)
      return {
        error: 'Wrong Username/Password combination'
      }
    })
  } catch (e) {
    console.error(e)
  }
}

Vue.prototype.$refreshToken = async function () {
  try {
    let params = {
      'grant_type': 'refresh_token',
      'refresh_token': this.$localStorage.get('refresh_token')
    }
    let text = 'patient:patient'
    let bytes = utf8Encode(text)
    let encoded = base64Encode(bytes)
    let headers = {
      headers: {
        'Authorization': 'Basic ' + encoded,
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }
    return await Axios.post(this.$apiUrl + 'oauth/token', qs.stringify(params), headers).then(resp => {
      if (!resp.data.error) {
        this.$clearLocalStorage()
        this.$localStorage.set('access_token', resp.data.access_token, (resp.data.expires_in * 1000))
        this.$localStorage.set('refresh_token', resp.data.refresh_token)
        this.$localStorage.set('token_type', resp.data.token_type, (resp.data.expires_in * 1000))
        this.$localStorage.set('expires_in', resp.data.expires_in, (resp.data.expires_in * 1000))
        this.$localStorage.set('scope', resp.data.scope, (resp.data.expires_in * 1000))
        this.$localStorage.set('loggedIn', true, (resp.data.expires_in * 1000))
        this.$localStorage.set('userid', resp.data.user.userId, (resp.data.expires_in * 1000))
        this.$localStorage.set('email', resp.data.user.email, (resp.data.expires_in * 1000))
        if(global.ClearTimeout){
          clearTimeout(global.ClearTimeout)
        }
        console.log('rt')
        global.ClearTimeout = setTimeout(function() {
          this.$refreshToken()
        }.bind(this), (resp.data.expires_in - (60 * 60)) * 1000)
        return Axios.get(this.$apiUrl + 'patient/getProfile', {
          headers: {
            'Authorization': 'Bearer ' + resp.data.access_token,
            'Content-type': 'application/json'
          }
        }).then(response => {
          if (response.data.response_code === 0) {
            let result = response.data.response
            let userDetails = {
              'username': result.Patient.firstName + ' ' + result.Patient.lastName,
              'firstName': result.Patient.firstName,
              'lastName': result.Patient.lastName,
              'photo': result.Patient.photo,
              'dob': result.Patient.dob,
              'phone1': result.Patient.phone1,
              'phone2': result.Patient.phone2,
              'sex': result.Patient.sex,
              'email': result.email,
              'credits': result.Patient.creditPoint
            }
            this.$localStorage.set('profile', userDetails, (resp.data.expires_in * 1000))
            return {
              msg: 'success'
            }
          } else {
            console.log(response.data.response_message)
            return {
              error: response.data.response_message
            }
          }
        }).catch(e => {
          console.log(e)
          return {
            error: e
          }
        })
      }else{
        this.$clearLocalStorage()
        return this.$clientCredentialToken()
        // return {
        //   error: resp.data.error
        // }
      }
    }).catch(e => {
      console.log(e)
      this.$clearLocalStorage()
      return this.$clientCredentialToken()
    })
  } catch (e) {
    this.$clearLocalStorage()
    return this.$clientCredentialToken()
  }
}

Vue.prototype.$verifyOTP = async function (username, otp) {
  try {
    let params = {
      'username': username,
      'otp': otp
    }
    let headers = {
      headers: {
        'Authorization': 'Bearer ' + this.$localStorage.get('access_token'),
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }
    return await Axios.post(this.$apiUrl + 'patient/verifyOTP', qs.stringify(params), headers).then(resp => {
      if (!resp.data.error) {
        this.$clearLocalStorage()
        this.$localStorage.set('access_token', resp.data.access_token, (resp.data.expires_in * 1000))
        this.$localStorage.set('refresh_token', resp.data.refresh_token)
        this.$localStorage.set('token_type', resp.data.token_type, (resp.data.expires_in * 1000))
        this.$localStorage.set('expires_in', resp.data.expires_in, (resp.data.expires_in * 1000))
        this.$localStorage.set('scope', resp.data.scope, (resp.data.expires_in * 1000))
        this.$localStorage.set('loggedIn', true, (resp.data.expires_in * 1000))
        this.$localStorage.set('userid', resp.data.user.userId, (resp.data.expires_in * 1000))
        this.$localStorage.set('email', resp.data.user.email, (resp.data.expires_in * 1000))

        console.log('vt')
        if(global.ClearTimeout){
          clearTimeout(global.ClearTimeout)
        }
        global.ClearTimeout = setTimeout(function() {
          this.$refreshToken()
        }.bind(this), (resp.data.expires_in - (60 * 60)) * 1000)

        return Axios.get(this.$apiUrl + 'patient/getProfile', {
          headers: {
            'Authorization': 'Bearer ' + resp.data.access_token,
            'Content-type': 'application/json'
          }
        }).then(response => {
          if (response.data.response_code === 0) {
            let result = response.data.response
            let userDetails = {
              'username': result.Patient.firstName + ' ' + result.Patient.lastName,
              'firstName': result.Patient.firstName,
              'lastName': result.Patient.lastName,
              'photo': result.Patient.photo,
              'dob': result.Patient.dob,
              'phone1': result.Patient.phone1,
              'phone2': result.Patient.phone2,
              'sex': result.Patient.sex,
              'email': result.email,
              'credits': result.Patient.creditPoint
            }
            this.$localStorage.set('profile', userDetails, 0)
            return {
              msg: 'success'
            }
          } else {
            console.log(response.data.response_message)
            return {
              error: response.data.response_message
            }
          }
        }).catch(e => {
          console.log(e)
          return {
            error: e
          }
        })
      } else {

      }
      return {
        'error': response.data.error
      }
    }).catch(e => {
      console.log(e)
      return {error: 'Wrong Email/Password combination'}
    })
  } catch (e) {
    console.error(e)
  }
}

Vue.prototype.$verifyLoginOTP = async function (username, otp) {
  try {
    let params = {
      'username': username,
      'otp': otp
    }
    let headers = {
      headers: {
        'Authorization': 'Bearer ' + this.$localStorage.get('access_token'),
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }
    return await Axios.post(this.$apiUrl + 'patient/verifyLoginOTP', qs.stringify(params), headers).then(resp => {
      if (!resp.data.error) {
        this.$clearLocalStorage()
        this.$localStorage.set('access_token', resp.data.access_token, (resp.data.expires_in * 1000))
        this.$localStorage.set('refresh_token', resp.data.refresh_token)
        this.$localStorage.set('token_type', resp.data.token_type, (resp.data.expires_in * 1000))
        this.$localStorage.set('expires_in', resp.data.expires_in, (resp.data.expires_in * 1000))
        this.$localStorage.set('scope', resp.data.scope, (resp.data.expires_in * 1000))
        this.$localStorage.set('loggedIn', true, (resp.data.expires_in * 1000))
        this.$localStorage.set('userid', resp.data.user.userId, (resp.data.expires_in * 1000))
        this.$localStorage.set('email', resp.data.user.email, (resp.data.expires_in * 1000))

        console.log('vt')
        if(global.ClearTimeout){
          clearTimeout(global.ClearTimeout)
        }
        global.ClearTimeout = setTimeout(function() {
          this.$refreshToken()
        }.bind(this), (resp.data.expires_in - (60 * 60)) * 1000)

        return Axios.get(this.$apiUrl + 'patient/getProfile', {
          headers: {
            'Authorization': 'Bearer ' + resp.data.access_token,
            'Content-type': 'application/json'
          }
        }).then(response => {
          if (response.data.response_code === 0) {
            let result = response.data.response
            let userDetails = {
              'username': result.Patient.firstName + ' ' + result.Patient.lastName,
              'firstName': result.Patient.firstName,
              'lastName': result.Patient.lastName,
              'photo': result.Patient.photo,
              'dob': result.Patient.dob,
              'phone1': result.Patient.phone1,
              'phone2': result.Patient.phone2,
              'sex': result.Patient.sex,
              'email': result.email,
              'credits': result.Patient.creditPoint
            }
            this.$localStorage.set('profile', userDetails, 0)
            return {
              msg: 'success'
            }
          } else {
            console.log(response.data.response_message)
            return {
              error: response.data.response_message
            }
          }
        }).catch(e => {
          console.log(e)
          return {
            error: e
          }
        })
      } else {

      }
      return {
        'error': response.data.error
      }
    }).catch(e => {
      console.log(e)
      return {error: 'Wrong Email/Password combination'}
    })
  } catch (e) {
    console.error(e)
  }
}

Vue.prototype.$resetPassword = async function (password) {
  try {
    let params = {
      'password': password
    }
    let headers = {
      headers: {
        'Authorization': 'Bearer ' + this.$localStorage.get('access_token'),
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }
    return await Axios.post(this.$apiUrl + 'patient/resetPassword', qs.stringify(params), headers).then(response => {
      if (!response.data.error) {
        return {
          msg: 'success'
        }
      }
      return {
        'error': response.data.error
      }
    }).catch(e => ({
      error: 'Wrong Email/Password combination'
    }))
  } catch (e) {
    console.error(e)
  }
}

Vue.prototype.$GET = async function (url, params) {
  try {
    let data = {
      params: params,
      headers: {
        'Authorization': 'Bearer ' + this.$localStorage.get('access_token'),
        'Content-type': 'application/json'
      }
    }
    return await Axios.get(this.$apiUrl + url, data).then(response => {
      let results = []
      if (response.data.error === undefined) {
        results = response.data
      }
      return results
    }).catch(e => {
      if(e.response.data.statusCode == 401) {
        return this.$clientToken().then(token => {
          return this.$GET(url, params)
        })
      } else {
        return false
      }
    })
  } catch (e) {
    console.error(e)
  }
}

Vue.prototype.$POST = async function (url, params) {
  try {
    let headers = {
      headers: {
        'Authorization': 'Bearer ' + this.$localStorage.get('access_token'),
        'Content-type': 'application/json'
      }
    }
    return await Axios.post(this.$apiUrl + url, params, headers).then(response => {
      let results = []
      if (!response.data.error) {
        results = response.data
      }
      return results
    }).catch(e => {
      if(e.response.data.statusCode == 401) {
        return this.$clientToken().then(token => {
          return this.$POST(url, params)
        })
      } else {
        return false
      }
    })
  } catch (e) {
    console.error(e)
  }
}

export default {
  name: 'Webservice'
}



// WEBPACK FOOTER //
// ./src/webservice.js